if (!customElements.get('collection-cards-swiper')) {
  customElements.define('collection-cards-swiper', class extends HTMLElement {
    constructor() {
      super();

      this.gap = this.getAttribute('gap') || 10;
      this.swiper = null;

      this.debouncedHandleResize = this.debounce(this.handleResize, 300);
      this.isInit = false;
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    connectedCallback() {
      this.initSwiper();
      window.addEventListener('resize', this.debouncedHandleResize);
    }
    
    initSwiper() {
      this.swiper = new Swiper(this, {
        spaceBetween: this.gap,
        slidesPerView: 1,
        breakpoints: {
          750: {
            slidesPerView: 2,
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      this.isInit = true;
    }

    handleResize() {
      if (window.innerWidth < 990 && !this.isInit) {
        this.initSwiper();
      } else if (window.innerWidth > 990 && this.isInit) {
        this.swiper.destroy();
        this.isInit = false;
      }
    }

    disconnectedCallback() {
      document.removeEventListener('resize', this.handleResize);
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  });
}

